// Common IANA time zones for business hours selections, with Windows-friendly labels

export interface TimeZoneOption {
  label: string; // user-facing label (Windows-like)
  value: string; // IANA time zone ID
}

export const timeZones: TimeZoneOption[] = [
  { label: "Coordinated Universal Time (UTC)", value: "UTC" },
  // Africa
  { label: "Greenwich Mean Time (Abidjan)", value: "Africa/Abidjan" },
  { label: "Greenwich Mean Time (Accra)", value: "Africa/Accra" },
  { label: "(UTC+02:00) Cairo", value: "Africa/Cairo" },
  { label: "(UTC+01:00) Casablanca", value: "Africa/Casablanca" },
  { label: "(UTC+02:00) Johannesburg", value: "Africa/Johannesburg" },
  { label: "(UTC+01:00) Lagos", value: "Africa/Lagos" },
  { label: "(UTC+03:00) Nairobi", value: "Africa/Nairobi" },
  // America
  { label: "(UTC-09:00) Alaska", value: "America/Anchorage" },
  {
    label: "(UTC-03:00) Buenos Aires",
    value: "America/Argentina/Buenos_Aires",
  },
  { label: "(UTC-05:00) Bogota", value: "America/Bogota" },
  { label: "(UTC-04:00) Caracas", value: "America/Caracas" },
  { label: "Central Time (US & Canada)", value: "America/Chicago" },
  { label: "Mountain Time (US & Canada)", value: "America/Denver" },
  { label: "(UTC-07:00) Edmonton", value: "America/Edmonton" },
  { label: "(UTC-06:00) Guatemala", value: "America/Guatemala" },
  { label: "(UTC-03:00) Halifax", value: "America/Halifax" },
  { label: "(UTC-04:00) La Paz", value: "America/La_Paz" },
  { label: "(UTC-05:00) Lima", value: "America/Lima" },
  { label: "Pacific Time (US & Canada)", value: "America/Los_Angeles" },
  { label: "(UTC-06:00) Mexico City", value: "America/Mexico_City" },
  { label: "Eastern Time (US & Canada)", value: "America/New_York" },
  { label: "(UTC-07:00) Arizona", value: "America/Phoenix" },
  { label: "(UTC-04:00) Puerto Rico", value: "America/Puerto_Rico" },
  { label: "(UTC-04:00) Santiago", value: "America/Santiago" },
  { label: "(UTC-03:00) Brasilia", value: "America/Sao_Paulo" },
  { label: "Eastern Time (Canada)", value: "America/Toronto" },
  { label: "Pacific Time (Canada)", value: "America/Vancouver" },
  // Asia
  { label: "(UTC+03:00) Amman", value: "Asia/Amman" },
  { label: "(UTC+03:00) Baghdad", value: "Asia/Baghdad" },
  { label: "(UTC+07:00) Bangkok", value: "Asia/Bangkok" },
  { label: "(UTC+02:00) Beirut", value: "Asia/Beirut" },
  { label: "(UTC+05:30) Colombo", value: "Asia/Colombo" },
  { label: "(UTC+06:00) Dhaka", value: "Asia/Dhaka" },
  { label: "(UTC+04:00) Abu Dhabi, Muscat", value: "Asia/Dubai" },
  { label: "(UTC+07:00) Ho Chi Minh City", value: "Asia/Ho_Chi_Minh" },
  { label: "(UTC+08:00) Hong Kong", value: "Asia/Hong_Kong" },
  { label: "(UTC+07:00) Jakarta", value: "Asia/Jakarta" },
  { label: "(UTC+02:00) Jerusalem", value: "Asia/Jerusalem" },
  { label: "(UTC+05:00) Karachi", value: "Asia/Karachi" },
  { label: "(UTC+05:45) Kathmandu", value: "Asia/Kathmandu" },
  {
    label: "(UTC+05:30) Chennai, Kolkata, Mumbai, New Delhi",
    value: "Asia/Kolkata",
  },
  { label: "(UTC+08:00) Kuala Lumpur", value: "Asia/Kuala_Lumpur" },
  { label: "(UTC+08:00) Manila", value: "Asia/Manila" },
  { label: "(UTC+03:00) Riyadh", value: "Asia/Riyadh" },
  { label: "(UTC+09:00) Seoul", value: "Asia/Seoul" },
  { label: "(UTC+08:00) Shanghai", value: "Asia/Shanghai" },
  { label: "(UTC+08:00) Singapore", value: "Asia/Singapore" },
  { label: "(UTC+08:00) Taipei", value: "Asia/Taipei" },
  { label: "(UTC+03:30) Tehran", value: "Asia/Tehran" },
  { label: "(UTC+09:00) Tokyo", value: "Asia/Tokyo" },
  // Australia & Pacific
  { label: "(UTC+09:30) Adelaide", value: "Australia/Adelaide" },
  { label: "(UTC+10:00) Brisbane", value: "Australia/Brisbane" },
  { label: "(UTC+10:00) Melbourne", value: "Australia/Melbourne" },
  { label: "(UTC+08:00) Perth", value: "Australia/Perth" },
  { label: "(UTC+10:00) Sydney", value: "Australia/Sydney" },
  { label: "(UTC+12:00) Auckland", value: "Pacific/Auckland" },
  { label: "(UTC+12:00) Fiji", value: "Pacific/Fiji" },
  { label: "(UTC+10:00) Guam", value: "Pacific/Guam" },
  { label: "Hawaii Standard Time", value: "Pacific/Honolulu" },
  // Europe
  { label: "(UTC+01:00) Amsterdam", value: "Europe/Amsterdam" },
  { label: "(UTC+02:00) Athens", value: "Europe/Athens" },
  { label: "Central European Time (Berlin)", value: "Europe/Berlin" },
  { label: "(UTC+01:00) Brussels", value: "Europe/Brussels" },
  { label: "(UTC+02:00) Bucharest", value: "Europe/Bucharest" },
  { label: "(UTC+01:00) Budapest", value: "Europe/Budapest" },
  { label: "(UTC+01:00) Copenhagen", value: "Europe/Copenhagen" },
  { label: "(UTC+00:00) Dublin", value: "Europe/Dublin" },
  { label: "(UTC+02:00) Helsinki", value: "Europe/Helsinki" },
  { label: "(UTC+03:00) Istanbul", value: "Europe/Istanbul" },
  { label: "(UTC+03:00) Kyiv", value: "Europe/Kyiv" },
  { label: "(UTC+00:00) Lisbon", value: "Europe/Lisbon" },
  {
    label: "(UTC+00:00) Dublin, Edinburgh, Lisbon, London",
    value: "Europe/London",
  },
  { label: "(UTC+01:00) Madrid", value: "Europe/Madrid" },
  { label: "(UTC+03:00) Moscow", value: "Europe/Moscow" },
  { label: "(UTC+01:00) Oslo", value: "Europe/Oslo" },
  { label: "(UTC+01:00) Paris", value: "Europe/Paris" },
  { label: "(UTC+01:00) Prague", value: "Europe/Prague" },
  { label: "(UTC+01:00) Rome", value: "Europe/Rome" },
  { label: "(UTC+01:00) Stockholm", value: "Europe/Stockholm" },
  { label: "(UTC+01:00) Vienna", value: "Europe/Vienna" },
  { label: "(UTC+01:00) Warsaw", value: "Europe/Warsaw" },
  { label: "(UTC+01:00) Zurich", value: "Europe/Zurich" },
];

export default timeZones;
